import { useState } from 'react';
import { ModalComponent } from '../baseComponents';
import { Input, Radio } from 'antd';
import { useSelector } from 'react-redux';

export const SavedSearchModal = ({
  isModalVisible,
  handleCloseView,
  parseStoredNames,
  savePatientName,
  saveDate,
  saveStatus,
  setRenameTitle,
  renameTitle,
  setDuplicateError,
  duplicateError,
  handleSaveAppDuplicate,
  setSelectedTitle,
  isDefaultAppointmentView,
  setDefaultAppointmentView,
}) => {
  const [showError, setShowError] = useState(false);

  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );

  const onChangeHandler = (event) => {
    const value = event.target.value;
    setRenameTitle(value);
    setSelectedTitle(value);
    localStorage.setItem(
      `${currentPractitioner?.org_uuid}_selectedTitle`,
      value
    );
    if (value === '') {
      setShowError(true);
      setDuplicateError(false);
    } else {
      setShowError(false);
    }
  };
  const onChange = (e) => {
    setDefaultAppointmentView(e.target.value);
  };
  return (
    <>
      <ModalComponent
        centered={true}
        open={isModalVisible}
        handleSubmit={
          renameTitle?.trim() !== ''
            ? handleSaveAppDuplicate
            : () => setShowError(true)
        }
        handleCancel={handleCloseView}
        className={'notificationHistory-page-table'}
        submitButtonText="Save"
        cancelButtonText="Cancel"
        closable={true}
        additionalBody={
          <>
            <div className="mb-5 font-medium text-xl">Save view</div>
            <div className=" space-y-2 ">
              <div className="font-medium">
                Practitioner Name:{' '}
                {parseStoredNames.length > 0 ? (
                  parseStoredNames.map((name, index) => (
                    <span className="text-gray-500" key={index}>
                      {name}
                      {index < parseStoredNames.length - 1 ? ', ' : ''}
                    </span>
                  ))
                ) : (
                  <span className="text-gray-500">N/A</span>
                )}
              </div>
              <div className="font-medium ">
                Patient Name:{' '}
                <span className="text-gray-500">
                  {savePatientName ? savePatientName : 'N/A'}
                </span>
              </div>
              <div className="font-medium ">
                Date: {'  '}
                <span className="text-gray-500">
                  {saveDate ? saveDate : 'N/A'}
                </span>
              </div>
              <div className="font-medium ">
                Status:{' '}
                <span className="text-gray-500">
                  {' '}
                  {saveStatus ? saveStatus : 'All'}
                </span>
              </div>
              <div className="font-medium ">
                Set as Default: {'  '}
                <span className="text-gray-500 ml-1">
                  <Radio.Group
                    onChange={onChange}
                    value={isDefaultAppointmentView}
                    options={[
                      {
                        value: true,
                        label: 'Yes',
                      },
                      {
                        value: false,
                        label: 'No',
                      },
                    ]}
                  />
                </span>
              </div>
            </div>

            <div className="mt-3 flex items-center bg-white border border-[#e5e8eb] rounded-xl">
              <Input
                id="Save view"
                bordered={false}
                placeholder="Enter a name for this view"
                className="h-14"
                value={renameTitle}
                onChange={onChangeHandler}
              />
            </div>
            {showError && (
              <div style={{ color: 'red' }}>
                Please enter a name for this view.
              </div>
            )}
            {duplicateError && (
              <div style={{ color: 'red' }}>
                This name already exists. Please enter a different name.
              </div>
            )}
          </>
        }
      />
    </>
  );
};
